// **************************************************************************************************************
import {CART_CREATE_SUCCESS, CART_RECOMMEND_SUCCESS} from "../constants/ActionTypes";
import {delve} from "../util/util";

export const outsourcingReducer = (state = {pin: false, presetId: false, expireDate: false, isCopied: false, initialCommission: false}, action) => {

    switch (action.type) {


        case CART_CREATE_SUCCESS:

            const cart = delve(action, "response.result");

            if (cart && cart.isAllowedForCustomerChange && cart.commission && !state.initialCommission) {

                return Object.assign({}, state, {initialCommission: cart.commission});

            }

            return state;

        case CART_RECOMMEND_SUCCESS:

            return Object.assign({}, state, {
                expireDate: action.response.result.expireDate,
                pin: action.response.result.pin,
                presetId: action.response.result.id,
                url: action.response.result.url,
                isCopied: false
            });

        default:
            return state
    }
}



/** WEBPACK FOOTER **
 ** ./src/reducers/Outsourcing.js
 **/